// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"98f954a2","173":"73eab652","220":"82092106","404":"1e6993cb","449":"a1a29d7b","453":"155cdfbc","743":"ed7e1ebf","802":"72d62b65","948":"3b227458"}[chunkId] + ".chunk.js";
};